import styled from 'styled-components';

export const InsideContent = styled.div`
  @media (max-width: 590px) {
    width: 100%;
  }
`;
export const SubHeaderWrap = styled.div`
  margin-bottom: 30px;
`;
